<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Dr. Ammar Haouimi is a French trained internationally renowned radiologist and educator. His authored publications are:</p>
<br/>
<div style="float:left;"><p style="text-indent:0em;">-</p> </div><div style="padding-left:10px;"><p style="text-indent:0px;">Radiology for FRCR and MRCP 111 Cases</p></div>
<div style="float:left;"><p style="text-indent:0em;">-</p> </div><div style="padding-left:10px;"><p style="text-indent:0px;">Neuroradiology for FRCR and MRCP 111 Cases</p></div>
<div style="float:left;"><p style="text-indent:0em;">-</p> </div><div style="padding-left:10px;"><p style="text-indent:0px;">Pediatric Radiology Case Report 111 Common Cases</p></div>
<div style="float:left;"><p style="text-indent:0em;">-</p> </div><div style="padding-left:10px;"><p style="text-indent:0px;">Atlas of Pediatric Radiology 200 Common Cases</p></div>
<div style="float:left;"><p style="text-indent:0em;">-</p> </div><div style="padding-left:10px;"><p style="text-indent:0px;">Atlas of Neuroradiology 200 Common Cases</p></div>
<br/>
<p style="text-indent:0px;
">Those publications were very successful and were enthusiastically welcomed by candidates appearing for Royal College Examinations. Like all previous publications, the current “Abdominal-Pelvic Imaging” will no doubt be another exceptional one. This book will not only be extremely helpful for residents, but also for referring physicians and practicing radiologists internationally.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?045fe175